import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import { 
  saveUserContest as saveUserContestApi,
  getAllContest as getAllContestApi,
  getContestDetail as getContestDetailApi,
  createContest as createContestApi,
  createParticipateContest as createParticipateContestApi,
  saveContestResult as saveContestResultApi,
  getContestResult as getContestResultApi, 
  saveContestStatus as saveContestStatusApi,
  resultSendToClient as resultSendToClientApi,
  handleStartDesign as handleStartDesignApi,
  getAllStatuses as getAllStatusesApi,
  addWinnerRewards as addWinnerRewards,

 } from "../../helpers/custom_helper/backend_helper";

export const userContestThunk = createAsyncThunk( "saveUserContest",async (userData, { rejectWithValue }) => {
    try {

      const response = await saveUserContestApi(userData);
      if (response.success) {
        return response.data;
      } else {
        toast.error(response.message || "Login failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);
 export const getAllContestThunk = createAsyncThunk("get-all-contest", async (contestData) => {
  try {
    
     const response = getAllContestApi(contestData);
     const data = await response;
     // need to filter our array, we will check if contestData showRefferalContest is 1 then we will show all other wise we will on show only those contest whose is_refferal_contest is 2  

    //  console.log("contestData in thunk", contestData);
    //  console.log("response in thunk", response);
    //  console.log("data in thunk", data);
     //lets update data.data
      data.data = data.data.filter(contest => {
        if(contestData.showRefferalContest == 1){
          return true; // Show all contests
        } else {
          return contest.is_referral_contest == '2'; // Show only referral contests
        } 
      });
    //  console.log("data in thunk", data);

      
  
    if(data.success)
    {
      return response;
    }else {

        return data;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});
 export const getContestDetailThunk = createAsyncThunk("get-contest-details", async (contestId) => {
  try {
     const response = getContestDetailApi(contestId);

    const data = await response;
    if(data.success)
    {
      return response;
    }else {
        return response;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});
export const createContestThunk = createAsyncThunk( "createContest",async (data, { rejectWithValue }) => {
    try {
      const response = await createContestApi(data);
     
      if (response.success) {
        return response.data;
      } else {
        toast.error(response.message || "Contest not created");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);
export const resetContestThunk = createAsyncThunk( "resetContest",async () => {
    try {
      return true;
    } catch (error) {
      return error;
    }
  }
);

export const createParticipateContestThunk = createAsyncThunk( "creatParticipateContest",async (data, { rejectWithValue }) => {
    try {
 
      const response = await createParticipateContestApi(data);
      if (response.success) {
        toast.success(response.message)
        return response.data;
      } else {
        toast.error(response.message || "Contest not created");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);


export const saveContestResultThunk = createAsyncThunk( "saveContestResult",async (userData, { rejectWithValue }) => {
    try {

      const response = await saveContestResultApi(userData);
    
      if (response.success) {
        toast.success(response.message);
        return response.data;
      } else {
        toast.error(response.message || "Something went wrong");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);


 export const getContestResultThunk = createAsyncThunk("get-contest-result", async (contestData) => {
  try {
     const response = getContestResultApi(contestData);
     const data = await response;
    if(data.success)
    {
      return response;
    }else {
          toast.error(data.message);
        return data;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});


export const saveContestPublishStatusThunk = createAsyncThunk( "saveContestPublishStatus",async (userData, { rejectWithValue }) => {
    try {

      const response = await saveContestStatusApi(userData);
      if (response.success) {
        toast.success(response.message);
        return response.data;
      } else {
        toast.error(response.message || "Something went wrong");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);

export const resultSendToClientThunk = createAsyncThunk( "resultSendToClient",async (userData, { rejectWithValue }) => {
    try {

      const response = await resultSendToClientApi(userData);
      if (response.success) {
        toast.success('Winner selected successfully');
        return response.data;
      } else {
        toast.error(response.message || "Something went wrong");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);


export const handleStartDesignThunk = createAsyncThunk("handleStartDesign",async (data, { rejectWithValue }) => {
    try {
      const response = await handleStartDesignApi(data);
      if (response.success) {
        toast.success(response.message)
        return response.data;
      } else {
        toast.error(response.message || "Contest not created");
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);

 export const getAllStatusesThunk = createAsyncThunk("get-all-statuses", async () => {
  try {
     const response = getAllStatusesApi();
     const data = await response;
  
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});
 export const onSaveWinnerRewardThunk = createAsyncThunk("on-save-reward", async (payload) => {
  try {
     const response = addWinnerRewards(payload);
     const data = await response;
  
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
    toast.error(error);
      return error;
  }
});


